module.exports = __webpack_public_path__ + "static/media/laptop.ee0b02f6.svg";